<h3 mat-dialog-title>Organization Return Address</h3>

<mat-dialog-content>
    <p><em>This required address should represent a return address for your organization.</em></p>
    <form [formGroup]="orgModel" novalidate>
        <div class="form-group">
            <label>
                Address Line 1 *
            </label>

            <input class="form-control"
                   formControlName="address1"
                   required/>
            <div class="text-error" *ngIf="isFieldInvalid('address1')">{{errorMessage}}</div>
        </div>

        <div class="form-group">
            <label>
                Address Line 2 (optional)
            </label>

            <input class="form-control"
                   formControlName="address2"/>
            <div class="text-error" *ngIf="isFieldInvalid('address2')">{{errorMessage}}</div>
        </div>


        <div class="form-group">
            <label>
                City *
            </label>

            <input class="form-control"
                   formControlName="city"
                   required/>
            <div class="text-error" *ngIf="isFieldInvalid('city')">{{errorMessage}}</div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>
                        State/Province *
                    </label>

                    <lf-geo-region-selector formControlName="region"
                                            ngDefaultControl
                                            required></lf-geo-region-selector>
                    <div class="text-error" *ngIf="isFieldInvalid('region')">{{errorMessage}}</div>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>
                        Zip Code *
                    </label>

                    <input class="form-control"
                           formControlName="zip"
                           required/>
                    <div class="text-error" *ngIf="isFieldInvalid('zip')">{{errorMessage}}</div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-dialog-close class="btn btn-outline-secondary" [disabled]="isSubmitting">
        Cancel
    </button>
    <button (click)="onSubmit()" class="btn btn-primary" [disabled]="isSubmitting">Save</button>
</mat-dialog-actions>
